// The analytics filter bar (analytics/shared/_filter_bar) holds the filters every analytics request
// runs over — the chart/table frames, question defaults, CSV export, drill-down and column-editor
// previews all read them from here, so a new filter control is markup only: give it
// data-dashboard-filters-target="filter" and data-filter-name="<param name>". A multi-select sends
// `name[]` per selected value; any other control sends `name`.

const FILTER_CONTROLS = "[data-dashboard-filters-target~='filter']"

// The bar's current selections, keyed by param name in bar order — a string, or an array for a
// multi-select — with blank values left out. Null-prototype so any filter name (even `__proto__`) is
// an ordinary key.
export function filterBarSelections(root = document) {
  const selections = Object.create(null)
  root.querySelectorAll(FILTER_CONTROLS).forEach((control) => {
    const name = control.dataset.filterName
    const value = control.multiple
      ? Array.from(control.selectedOptions).map((opt) => opt.value).filter(Boolean)
      : control.value
    if (name && value.length > 0) selections[name] = value
  })
  return selections
}

// `selections` as flat request params (the shape Analytics::Filters.from_params reads), appended to
// `into` — a URL's searchParams or a request body.
export function toParams(selections, into = new URLSearchParams()) {
  Object.entries(selections).forEach(([name, value]) => {
    if (Array.isArray(value)) value.forEach((v) => into.append(`${name}[]`, v))
    else into.append(name, value)
  })
  return into
}

// The bar's current selections as request params, appended to `into`.
export function filterBarParams(into = new URLSearchParams(), root = document) {
  return toParams(filterBarSelections(root), into)
}

// The filter param names whose selection differs between two filterBarSelections (every name when `before`
// is unknown — nothing has been applied yet).
export function changedFilterParams(before, after) {
  if (!before) return null
  const names = new Set([...Object.keys(before), ...Object.keys(after)])
  return new Set([...names].filter((name) => JSON.stringify(before[name]) !== JSON.stringify(after[name])))
}

// Whether a result frame must reload for `changed` (changedFilterParams): its data-filter-params lists the
// filters its SQL reads; a frame without it (or an unknown change) always reloads.
export function frameAffected(frame, changed) {
  const params = frame.dataset.filterParams
  if (changed === null || params === undefined) return true
  return params.split(" ").some((name) => changed.has(name))
}
